import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import classNames from 'classnames';

import { useIsMobile } from '../../hooks';
import { NavigationState } from '../../util/constants';
import { ButtonTypesEnum } from '../Button/Button.types';
import { Button, ClickableDiv } from '../index';
import { IProps } from '../Navigation/Navigation.types';

import styles from './NavButtons.module.scss';

const NavButtons = (props: IProps) => {
  const { tabs, rightSideLink, sendCurrentTabIndex, fullWidthButtons, isWatchlist, initialActiveTab } = props;
  const isMobile = useIsMobile();
  const history = useHistory();
  const [active, setActive] = useState(initialActiveTab ?? 0);

  const handleButtonClick = (index: number) => {
    sendCurrentTabIndex && sendCurrentTabIndex(index);
    setActive(index);
  };

  useEffect(() => {
    setActive(initialActiveTab ?? 0);
  }, [initialActiveTab]);

  return (
    <>
      <div className={classNames(styles.wrapper, { [styles.fullWidthButtons]: fullWidthButtons })}>
        <div className={styles.buttonsWrapper}>
          {/* TODO : Refactor this part and remove commented code HW-691 */}
          {/* {!isWatchlist && (
            <div
              className={styles.slidingBackground}
              style={isMobile ? {
                transform: `translateX(${active * 100}%)`,
              } : {
                transform: `translateX(${active * 86}%)`,
                width: active === 0 ? '104px' : '120px',
              }}
            />
          )}
          {isWatchlist && (
            <div
              className={styles.slidingBackground}
              style={isMobile ? {
                transform: `translateX(${active * 100}%)`,
              } : {
                transform: `translateX(${active * 76}%)`,
                width: active === 0 ? '80px' : '100px',
              }}
            />
          )} */}
          {tabs.map((tab, index) => (
            <ClickableDiv
              key={tab.text}
              onClick={() => handleButtonClick(index)}
              className={classNames(styles.button, {
                [styles.activeButton]: index === active,
                [styles.endButton]: index === 1,
              })}
            >
              {tab.text}
            </ClickableDiv>
          ))}
        </div>
        { rightSideLink && (
        <Button
          variant={ButtonTypesEnum.LinkSecondary}
          onClick={() => {
            if (rightSideLink.state) {
              history.push({ pathname: rightSideLink.link,
                state: {
                  [NavigationState]: rightSideLink.state,
                },
              });
            } else {
              history.push(rightSideLink.link);
            }
          }}
          className={styles.viewAll}
        >
          {rightSideLink.text}
        </Button>
        )}
      </div>
      {tabs[active].component}
    </>
  );
};

export default NavButtons;
